import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutProspectActivity } from "./autogen/AutogenLayoutProspectActivity";
import { DataDisplayEvent, DropdownSelectionEvent } from "@mcleod/components";

const url = "lme/crm/ProspectActivity?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "market_activity",
    screenName: "Market Activity",
    navigateToUrl: url,
    compositeKeyValues: {
        "type_of": "C"
    }
};

export class ProspectActivity extends AutogenLayoutProspectActivity {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxNextId. */
    textboxNextIdBeforeLookupModelSearch(event) {
        event.filter.type_of = "C";
        event.filter.id = "!RECCALL";
    }

    textboxDefAssignOnDataDisplay(event: DataDisplayEvent) {
        const defaultAssignment = event.rowData?.get("def_assign", null);
        this.setOtherUserByDefaultAssignment(defaultAssignment);
    }

    textboxDefAssignAfterDropdownSelection(event: DropdownSelectionEvent) {
        this.setOtherUserByDefaultAssignment(event.selection?.value);
    }

    setOtherUserByDefaultAssignment(defaultAssignment: string): void {
        this.textboxAssignedUserId.visible = "U" === defaultAssignment;
        if (!this.textboxAssignedUserId.visible) {
            this.activeRow?.set("assigned_user_id", null);
        }
    }
}